// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"_2qlFFtNS0IdwRpWMJ2rW5M _2HS5pq_sG-4tAB_x0bbn6Z","layoutWrapperBackgroundLayer":"_2huQj9imqSwTKushGC-VpJ _1VVBEiJ0Yq6pgVYuxEH73x"};